module.exports = __webpack_public_path__ + "media/15.da291575.mp3";